export default {
  modal: {
    defaultTitle: "Billing notice",
    defaultMessage: "Please visit your dashboard to manage billing.",
    primaryLabel: "Go to Dashboard",
    secondaryLabel: "Close",
  },
  notices: {
    oneOffExpiring: {
      title: "Your credits will expire soon",
      message:
        "Your one-time credits expire in 3 days. Renew now to keep your analysis uninterrupted.",
      primaryLabel: "Renew Now",
      secondaryLabel: "Later",
    },
    lowCredits: {
      title: "Low credits",
      message:
        "You have less than 5 credits remaining. Top up to continue advanced analysis.",
      primaryLabel: "Top Up",
      secondaryLabel: "Not Now",
    },
    insufficientCredits: {
      title: "Not enough credits",
      message:
        "This feature requires {requiredCredits} credits, but you only have {totalCredits}.",
      primaryLabel: "Top Up",
      secondaryLabel: "Cancel",
    },
    trialCreditsGranted: {
      title: "Your welcome credits are here!",
      message: "You've received {granted} trial credits to get started with PhotoScope. Upload an image to begin.",
      primaryLabel: "Start Now",
      secondaryLabel: "Later",
    },
    trialCreditsGrantedGeneric: {
      title: "Your welcome credits are here!",
      message: "Trial credits have been added to your account. Upload an image to begin.",
      primaryLabel: "Start Now",
      secondaryLabel: "Later",
    },
    creditReminder: {
      title: "Your credits are waiting",
      message: "You haven't used your trial credits yet. Upload an image to see PhotoScope in action.",
      primaryLabel: "Upload Now",
      secondaryLabel: "Remind Me Later",
    },
  },
};
